import { Box, Input, Modal, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import MenuItem from '@mui/material/MenuItem';
import React, { useEffect, useState } from 'react';
import { addFile, getFiletypesOptions } from '../../services/FileService';
import {Auth} from "aws-amplify";

const FileUploadForm = (props) => {
	const [open, setOpen] = useState(props.open);

	const [fileTypeOptions, setFileTypeOptions] = useState();
	const [loadingFileTypeOptions, setLoadingFileTypeOptions] = useState(true);

	const [isSubmitting, setIsSubmitting] = useState(false);

	const [caption, setCaption] = useState('');
	const [fileType, setFileType] = useState();
	const [file, setFile] = useState();

	let [currentUser, setCurrentUser] = useState()

	useEffect(() => {
		getFiletypesOptions().then(response => {
			setFileTypeOptions(response);
			setFileType(response[0].value);
			setLoadingFileTypeOptions(false);
		})
		.catch(err => {
			console.log(err)
		});

		
        if (!currentUser) {
            Auth.currentUserInfo().then(response => {
                setCurrentUser(response.attributes.name)
            })
        }
	}, []);

	useEffect(() => {
		setOpen(props.open);
	}, [props.open])

	const handleClose = () => setOpen(props.closeModal);
	const handleCaptionChange = (event) => setCaption(event.target.value);
	const handleFileTypeChange = (event) => setFileType(event.target.value);
	const handleFileChange = (event) => {
			if (!event.target.files || event.target.files.length === 0) {
			throw new Error('You must select a file image to upload.');
			}
			setFile(event.target.files[0]);
	};

  async function handleSubmit(event) {
		event.preventDefault();
		setIsSubmitting(true);

		const [fileName, fileExt] = file.name.split('.');
		const fileNameUnique = `${fileName}_${Math.random()}.${fileExt}`;
		const entityKey = `${props.context}_${props.id}`

		let fileToUpload = {
			entityKey: entityKey,
			fileExt: fileExt,
			fileName: file.name,
			path: `${entityKey}/${fileNameUnique}`,
			file: file,
			caption: caption,
			fileTypeId: fileType,
			uploaded_by: currentUser,
		}

		addFile(fileToUpload).then(response => {
			props.onSubmit(fileToUpload);
			setIsSubmitting(false);
			handleClose();
		}).catch (error => {
			alert(error.message);
		}).finally (() => {
			setIsSubmitting(false);
		})
  }

  return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 350,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Upload File
          </Typography>
          {loadingFileTypeOptions ? (
            <p>Loading file type options...</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <Box flexDirection="column" display="flex">
			  <TextField
                  id="caption"
                  label="Caption"
                  variant="outlined"
                  sx={{ m: 2 }}
				  size="small"
                  value={caption}
                  onChange={handleCaptionChange}
                  multiline
                />
                <TextField
                  id="filetype"
                  label="File type"
                  variant="outlined"
                  select
                  sx={{ m: 2 }}
				  size="small"
                  value={fileType}
                  onChange={handleFileTypeChange}
                  required
                >
                  {fileTypeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <Input
                  type="file"
                  id="file"
                  onChange={handleFileChange}
                  disabled={loadingFileTypeOptions}
                  sx={{ m: 2 }}
				  size="small"
                  required={true}
                />

                <LoadingButton variant="contained" loading={isSubmitting} type="submit">
                  Submit
                </LoadingButton>
              </Box>
            </form>
          )}
        </Box>
      </Modal>
  )
};

export default FileUploadForm;
